import axios from 'axios'
import i18n from '@/lang'
import { Toast } from 'vant'
import router from '@/router'
// import { LANGUAGE_TYPE } from '@/config/global_data'



const la = navigator.language.toLowerCase();
let language = 'en';
if (la.indexOf('zh') != -1) language = 'zh';
const URL = window.global;

let BASE_URL = URL[Object.keys(URL)[0]];
// console.log(BASE_URL)
for (let key in URL) {
  if (key == language) BASE_URL = URL[key];
}

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 60000 // request timeout
})
// request拦截器
instance.interceptors.request.use(
  config => {

    let token = ''

    //判断token
    if (window.localStorage.getItem("user")) {
      token = JSON.parse(window.localStorage.getItem("user")).token;
    }
    config.headers['Authorization'] = 'Bearer ' + token
    // config.headers['lang'] = language || LANGUAGE_TYPE[0].value
    config.headers['Accept-Language'] = language || 'en'
    return config
  },
  error => {
    Toast.clear()
    console.error(error) // for debug
    return Promise.reject(error)
  }
)

// respone拦截器
instance.interceptors.response.use(
  response => {
    // Toast.clear()
    const res = response.data
    // console.log(res, response)
    //特殊接口直接return
    if (response.config.url == '/captcha/api/default' || response.config.url == '/api/logout' || response.config.url == '/api/identity-auths') {
      return res
    }
    if (res.code !== 200) {
      if (res.code === 401) {
        return res
      } else {
        Toast({
          message: res.message || 'Error',
          duration: 3 * 1000
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Toast({
      message: error.response.data.message,
      duration: 3 * 1000
    })
    console.log(error.response)
    return Promise.reject(error.response)
  }
)

// GET请求
export const requestGet = (url, params) => instance.get(url, { params })
// DELETE请求
export const requestDelete = (url, params) => instance.delete(url, { params })
// POST请求
export const requestPost = (url, params) => instance.post(url, params)
// PUT请求
export const requestPut = (url, params) => instance.put(url, params)

export default instance
